import { render, staticRenderFns } from "./education-picture.vue?vue&type=template&id=b7e01ff8&scoped=true&"
import script from "./education-picture.vue?vue&type=script&lang=js&"
export * from "./education-picture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e01ff8",
  null
  
)

export default component.exports